var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.blockoutDay.inEditMode &&
    !_vm.blockoutDay.inAddMode &&
    !_vm.isEndDateAlreadyPassed(_vm.blockoutDay)
    ? _c(
        "md-button",
        {
          staticClass: "md-danger md-just-icon md-round",
          class:
            _vm.disableActionButtons && !_vm.blockoutDay.inAddMode
              ? "md-disabled"
              : "",
          attrs: {
            disabled: _vm.disableActionButtons && !_vm.blockoutDay.inAddMode,
            title: "Delete blockout day",
          },
          on: {
            click: function ($event) {
              return _vm.handleDeleteBlockoutDay()
            },
          },
        },
        [_c("md-icon", [_vm._v("delete")])],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }